import { FC } from "react";
import classes from './adminDownloadTutors.module.scss'
import { UsersDocumentsRegistry } from '../../documents'
import { OpenContainer } from '../../../features/openContainer'
import { useAppSelector } from '../../../app/store/store'
import { FEATURES, hasFeatureGrant } from '../../../entities/my'

export const AdminDownloadTutors: FC = () => {
    const {my} = useAppSelector(state => state.myReducer)
    if(!hasFeatureGrant(my, FEATURES.DOCUMENTS.VIEW)){
        return null
    }

    return (
        <section className={classes.container}>
            <OpenContainer
                title="Документы сотрудников"
                allowOverflow
                rotateChevron={false}
                icon={<svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M6 3H14L19 8V21H6V3Z" />
                    <path d="M14 3V8H19M9 13H16M9 17H14" />
                </svg>}
            >
                <UsersDocumentsRegistry embedded />
            </OpenContainer>
        </section>
    )
}
